import { Component, OnInit, Output, EventEmitter } from '@angular/core';
// tslint:disable-next-line:max-line-length
import { resolvedCaptcha, isEmpty, openModalMensaje, isNotEmpty, ConvertStringDateStr, docInstrucciones, rutaDocs, saveContent, recupContenidoEmail, GlobalVars, cookieGlobalVars, cambiarRouter, DscMensajeSpinner,  ParametroVars , servicioToken, loadCaptcha01 , uuid } from 'src/app/general/variables';
import { MatDialog } from '@angular/material';
import { FurService } from 'src/app/services/fur.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FrmFURPorCodigoBorrador } from 'src/app/models/FrmFURPorCodigoBorrador';
import { ValidarFechaLength } from 'src/app/general/Funciones';
import { CorreoBpm } from 'src/app/models/CorreoBpm';
import { CorreoDetalleBpm } from 'src/app/models/CorreoDetalleBpm';
import { Fur } from 'src/app/models/Fur';
import { ExternosService } from 'src/app/services/externos/externos.service';
import { ParametroService } from 'src/app/services/parametro.service';
import { Router } from '@angular/router';
import { LoginMovil } from 'src/app/models/LoginMovil';
import { EntidadService } from 'src/app/services/entidad/entidad.service';
@Component({
  selector: 'app-acceda-denuncia',
  templateUrl: './acceda-denuncia.component.html',
  styleUrls: ['./acceda-denuncia.component.css']
})
export class AccedaDenunciaComponent implements OnInit {


  constructor(public dialog: MatDialog,
              protected furService: FurService
    ,
              private spinner: NgxSpinnerService,
    // public f: SpeechSynthesisUtteranceFactoryService,
    // public svc: SpeechSynthesisService,
    // private cookieService: CookieService,
              protected externosService: ExternosService,
              protected parametroService: ParametroService,
              public router: Router,
              protected entidadService: EntidadService
    ) { }
  url = `${servicioToken}`;
  flgCaptcha = false;
  strCodigo1 = '';
  strCodigo2 = '';
  strCodigo3 = '';
  strDFechaRegistro = '';
  strClave = '';
  strAnnoActual = '';
  // strCodValCaptcha:string = "KO";
  frmFURPorCodigoBorrador: FrmFURPorCodigoBorrador;
  // strRutaDocs = rutaDocs;
  // strDocInstrucciones = docInstrucciones;
  // iconoMatEscuchar = iconoMatEscuchar;
  strDscEnlaceApp = '';
  strDscEnlaceDocEmail = '';
  DscMensajeSpinner: string = DscMensajeSpinner;


  @Output() accedaDenunciaOut = new EventEmitter();
  @Output() accedaDenunciaSalirOut = new EventEmitter();
    urlImagen2: any;

  // loadFormAssets() {
  //   return new Promise(resolve => {

  //     const scriptElement = document.createElement('script');
  //     scriptElement.src = "assets/js/captcha.js";
  //     scriptElement.onload = resolve;
  //     document.body.appendChild(scriptElement);

  //     const scriptElement1 = document.createElement('script');
  //     scriptElement1.src = "assets/js/document-captcha.js";
  //     scriptElement1.onload = resolve;
  //     scriptElement1.async = true;
  //     scriptElement1.defer = true;
  //     document.body.appendChild(scriptElement1);

  //   });
  // }

  // _reproducirAudio()
  // {

  //   var string1 = this.cookieService.get("c");

  //   for (var i = 0; i < string1.length; i++) {

  //     this.svc.speak(this.f.text(string1.charAt(i)));
  //   }



  // }
  captchaId2;
  ngOnInit() {

    this.loadCaptcha();

    // try {

    //   setTimeout(() => {

    //     loadFormAssets().then(() => {console.log("Script Loaded");})
    //     .catch(() => {

    //       console.log("Script Problem");

    //     });

    //   }, 600);

    // } catch (e) {

    //   setTimeout(() => {

    //     loadFormAssets().then(() => {console.log("Script Loaded");})
    //     .catch(() => {

    //       console.log("Script Problem");

    //     });

    //   }, 600);

    // }

    // this.parametroService.obtenerParametro(NumIdParamLinkApp).subscribe(
    //   data => {

    //     this.strDscEnlaceApp = data.cparamValor;

    //   });

    this.strDscEnlaceApp = ParametroVars.Param17;


    // this.parametroService.obtenerParametro(NumIdParamLinkDocEmail).subscribe(
    //   data => {

    //     this.strDscEnlaceDocEmail = data.cparamValor;

    //   });

    this.strDscEnlaceDocEmail = ParametroVars.Param26;


    this.strAnnoActual = new Date().getFullYear().toString();

  }
  loadCaptcha() {
    this.captchaId2 = uuid(null, null);
    // console.log('UUID:', this.captchaId);
    this.urlImagen2 = loadCaptcha01(this.url, this.captchaId2);
  }


  _salirFormulario() {

    cambiarRouter(this.router, 1);


  }

  _descargarPdf() {

    const dscNombre = docInstrucciones;

    saveContent(rutaDocs + dscNombre, dscNombre);

  }

  _resolved(captchaResponse: string) {

    // console.log(`Resolved captcha with response: ${captchaResponse}`);

    this.flgCaptcha = resolvedCaptcha(captchaResponse);

  }
  _consultar() {
    const valCaptcha = (document.getElementById('textoCaptcha2') as HTMLInputElement).value;
    const data = {deviceId: this.captchaId2, textoCaptcha: valCaptcha};
    this.entidadService.validarcaptcha(data).subscribe(idata => {
      if (idata != null) {
        if (idata.success) {
          window.localStorage.setItem('tokenfv', 'Bearer ' + idata.token);
          this._consultar2();
        } else {
          openModalMensaje('Atención de Denuncias', 'Ingrese el Captcha correctamente, por favor verifique', this.dialog);
          return;
        }
      }
    },
    err => {console.error('Observer got an error: ' + err); },
    () => {});
  }
  _consultar2() {

    // var vCodBorrador = "";
    // var vFchRegistro = "";
   // var valCaptcha = (<HTMLInputElement>document.getElementById(IdCaptcha)).value//this.formLogin.controls..value;
    let vDscMensaje = '';

    if (isEmpty(this.strCodigo1) || isEmpty(this.strCodigo2) || isEmpty(this.strCodigo3)) {

      vDscMensaje = 'el número de registro';

    } else if (isEmpty(this.strDFechaRegistro)) {

      vDscMensaje = 'la fecha de registro';

    } else if (isEmpty(this.strClave)) {

      vDscMensaje = 'la clave';

    }
    if (isNotEmpty(vDscMensaje)) {

      openModalMensaje('Atención de Denuncias', 'Ingrese ' + vDscMensaje + ', por favor verifique', this.dialog);

      return;

    }

    // vCodBorrador = this.strCodigo1 + "." + this.strCodigo2 + "." + this.strCodigo3;
    // vFchRegistro = ConvertStringDateStr(this.strDFechaRegistro,2);

    this.spinner.show();

    this.frmFURPorCodigoBorrador = new FrmFURPorCodigoBorrador();

    this.frmFURPorCodigoBorrador.cfurCodborrador = this.strCodigo1 + '.' + this.strCodigo2 + '.' + this.strCodigo3;
    this.frmFURPorCodigoBorrador.cfurFecinicioreg = ConvertStringDateStr(this.strDFechaRegistro, 2);
    this.frmFURPorCodigoBorrador.cfurClavedenunc = this.strClave;

    // console.log("====this.frmFURPorCodigoBorrador.");
    // console.log(this.frmFURPorCodigoBorrador);

    this.furService.obtenerFurPorCodigoBorrador(this.frmFURPorCodigoBorrador).subscribe(

      data => {

        this.spinner.hide();

        if (data == null) {

          openModalMensaje('Atención de Denuncias', 'El número de registro no existe, por favor verifique', this.dialog);

          return;

        } else {

          // this.accedaDenunciaOut.emit(data);

          // console.log("=====data");
          // console.log(data);

          GlobalVars.objetoFurAcceda = data;
          GlobalVars.FlgNuevoFw = false;

          // console.log("====GlobalVars");
          // console.log(GlobalVars);

          cookieGlobalVars(3);

          cambiarRouter(this.router, 3);

        }

      }
      ,
      err => {

        this.spinner.hide();
        console.log(err);

      }
      );

  }

  _envioCorreo(fur: Fur, numCaso: number) {

    const correoBpm: CorreoBpm = new CorreoBpm();
    let dscCorreoDenunc = '';
    let strMensaje = '';
    let strBody = '';
    let strAsunto = '';
    let strDscMensajeRpta = '';
    // let boolFlgCodVerif:boolean = false;

    switch (numCaso) {
      case 1:

        if (fur.denunciante) {

          dscCorreoDenunc = fur.denunciante.cdenuncianteDsccorreo;

        }

        // tslint:disable-next-line:max-line-length
        strBody = `<p><i><span style=\"font-family: Century Gothic, CenturyGothic;\">Se ha restablecido la clave de su Alerta Ciudadana, con código: <b style=\"color:red;\">${fur.cfurCodborrador}</b>, presentada a la OEFA.<br></span></i></p></div>\r\n` +
          // tslint:disable-next-line:max-line-length
        `<p style=\"text-align: center;\"><i><span style=\"font-family: Century Gothic, CenturyGothic;\"><b>Nueva clave: <b style=\"color:red;\">${fur.cfurClavedenunc}</b></b><br></span></i></p></div>\r\n`;

        strAsunto = 'Restablecer clave';

        strDscMensajeRpta = 'Se reestableció la clave y fue remitido al correo registrado';

        break;

      case 2:

        dscCorreoDenunc = fur.strCorreoDenciante;

        // tslint:disable-next-line:max-line-length
        strBody = `<p><i><span style=\"font-family: Century Gothic, CenturyGothic;\">Para reestablecer la clave de acceso, por favor introduzca donde se indicó, el siguiente código:<br></span></i></p></div>\r\n` +
          // tslint:disable-next-line:max-line-length
        `<div style=\"text-align: center;\"><p><i><span style=\"font-family: Century Gothic, CenturyGothic;\"><b style=\"color:red;\">${fur.strCodVerificacion}</b><br></span></i></p></div></div>\r\n` +
          // tslint:disable-next-line:max-line-length
        `<p><i><span style=\"font-family: Century Gothic, CenturyGothic;\">Si no ha iniciado el reestablecimiento de su contraseña, ignore y elimine este mensaje.<br></span></i></p></div>\r\n`;

        strAsunto = 'Código de Verificación - Restablecer clave';

        strDscMensajeRpta = 'Se envió el código de verificación al correo registrado';

        // boolFlgCodVerif = true;

        break;


      default:
        break;
    }



    if (isNotEmpty(dscCorreoDenunc)) {

      strMensaje = recupContenidoEmail(strBody);

      correoBpm.listaMailDetalle = [];
      correoBpm.listaMailDetalle[0] = new CorreoDetalleBpm();
      correoBpm.listaMailDetalle[0].cbpmmaildetAsunto = strAsunto;
      correoBpm.listaMailDetalle[0].cbpmmaildetContenido = strMensaje;

      correoBpm.listaMailDetalle[0].cbpmmaildetDestinatario = dscCorreoDenunc;

      console.log('==========vCorreoBpm');
      console.log(JSON.stringify(correoBpm));

      this.spinner.show();

      this.externosService.registrarDatosCorreo(correoBpm).subscribe(data => {

        this.spinner.hide();

        if (data != null) {

          openModalMensaje('Atención de Denuncias', strDscMensajeRpta + ', por favor verifique', this.dialog);

          return;

        }

      },
      err => {


        this.spinner.hide();
        console.log(err);


        openModalMensaje('Atención de Denuncias', 'Inconvenientes con el servicio de correo', this.dialog);

        return;
      });

    }

  }

  _validarCodProteccion() {

    if (isEmpty(this.strCodigo1) || isEmpty(this.strCodigo2) || isEmpty(this.strCodigo3)) {

      openModalMensaje('Atención de Denuncias', 'Ingrese el número de registro , por favor verifique', this.dialog);

      return false;

    }

    return true;


  }

  _getCodProteccion() {

    return this.strCodigo1 + '.' + this.strCodigo2 + '.' + this.strCodigo3;


  }
  _reestablecerClave() {
    const valCaptcha2 = (document.getElementById('textoCaptcha2') as HTMLInputElement).value;
    const data2 = {deviceId: this.captchaId2, textoCaptcha: valCaptcha2};
    this.entidadService.validarcaptcha(data2).subscribe(idata => {
      if (idata != null) {
        if (idata.success) {
          window.localStorage.setItem('tokenfv', 'Bearer ' + idata.token);
          this._reestablecerClave2();
        } else {
          openModalMensaje('Atención de Denuncias', 'Ingrese el Captcha correctamente, por favor verifique', this.dialog);
          return;
        }
      }
    },
    err => {console.error('Observer got an error: ' + err); },
    () => {});
  }
  _reestablecerClave2() {

    const boolFlgOK: boolean  = this._validarCodProteccion();
    // console.log(boolFlgOK);
    if (boolFlgOK === false) {


      return;

    }

    // if(isEmpty(this.strCodigo1) || isEmpty(this.strCodigo2) || isEmpty(this.strCodigo3))
    // {

    //   openModalMensaje("Atención de Denuncias","Ingrese el número de registro , por favor verifique",this.dialog);

    //   return;

    // }


    this.spinner.show();

    this.frmFURPorCodigoBorrador = new FrmFURPorCodigoBorrador();

    // this.frmFURPorCodigoBorrador.cfurCodborrador = this.strCodigo1 + "." + this.strCodigo2 + "." + this.strCodigo3;
    this.frmFURPorCodigoBorrador.cfurCodborrador = this._getCodProteccion();

    this.furService.regenerarClaveDenunciaFur(this.frmFURPorCodigoBorrador).subscribe(

      data => {

        this.spinner.hide();

        if (data == null) {

          openModalMensaje('Atención de Denuncias', 'El número de registro no existe, por favor verifique', this.dialog);

          return;

        } else {

          this._envioCorreo(data, 1);


        }

      }
      ,
      err => {

        this.spinner.hide();
        console.log(err);

        openModalMensaje('Atención de Denuncias', 'Inconvenientes con el servicio que regenera clave', this.dialog);

        return;

      }
      );



  }

  _salir() {

    // this.accedaDenunciaSalirOut.emit();
    cambiarRouter(this.router, 1);

  }

  _cambioFechaReg() {

    this.strDFechaRegistro = ValidarFechaLength(this.strDFechaRegistro);


  }

  _mayusculas(e) {

    let vData = '';

    // console.log(e);
    e.target.value = e.target.value.toUpperCase();

    vData = e.target.value.trim();

    e.target.value = vData;
    this.strCodigo1 = vData;
    // this.nombreMadre = this.nombreMadre.toUpperCase();
    // e.key = e.key.toUpperCase();
   }

   _cambioNroReg(e) {

      let vData = '';

      e.target.value = ('0000000' + e.target.value).slice(-7);

      vData = e.target.value.trim();

      e.target.value = vData;

      this.strCodigo3 = vData;

   }

   _clicOlvidoClave() {

    const olvidoClave: LoginMovil = new LoginMovil();
    const boolFlgOK: boolean  = this._validarCodProteccion();

    if (boolFlgOK === false) {

      return;

    }

    olvidoClave.cfurCodigoBorrador = this._getCodProteccion();
    olvidoClave.strFlgOlvidoClave = '01';

    this.spinner.show();

    this.furService.obtenerFurPorLoginMovil(olvidoClave).subscribe(

      data => {

        console.log('=====OLVIDO CLAVE', data);

        this.spinner.hide();

        if (data == null) {

          openModalMensaje('Atención de Denuncias', 'Error al procesar Olvido clave, por favor verifique', this.dialog);

          return;

        } else {

          if (!data.strCorreoDenciante) {

            // tslint:disable-next-line:max-line-length
            openModalMensaje('Atención de Denuncias', 'La denuncia registrada no tiene consignado un correo electrónico, por favor verifique', this.dialog);

            return;

          } else {

            olvidoClave.strCorreoDen = data.strCorreoDenciante2;

          }

          this._envioCorreo(data, 2);

          GlobalVars.objOlvidoClave = olvidoClave;

          cookieGlobalVars(7);

          cambiarRouter(this.router, 6);


        }

      }
      ,
      err => {

        this.spinner.hide();
        console.log(err);

        openModalMensaje('Atención de Denuncias', 'Inconvenientes con el servicio de olvido de clave', this.dialog);

        return;

      }
      );


   }

}
